import { useQuery } from 'react-query'

import { DeduplicationService } from '../services'

export const useDeduplicationTrace = (runId: string, groupTraceId: string) =>
  useQuery(
    ['deduplication-group', runId, groupTraceId],
    () => DeduplicationService.getGroup(runId, groupTraceId),
    { enabled: !!runId && !!groupTraceId }
  )
